import { render, staticRenderFns } from "./PrePostTotalByMonth.vue?vue&type=template&id=d23c07ce"
import script from "./PrePostTotalByMonth.vue?vue&type=script&lang=js"
export * from "./PrePostTotalByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports